import { REQUEST_STATUSES } from "@/constants/index.js";

import * as types from "./types.js";
import { PublicVisualizationService, ShareService } from "../../../services";

export const getCurrentShare = (propertyId, experienceId, shareId, userId) => {
  return async (dispatch) => {
    dispatch({
      type: types.SET_CURRENT_SHARE_REQUEST_STATUS,
      payload: { status: REQUEST_STATUSES.LOADING },
    });

    const payload = {};

    if (!experienceId) {
      // This is related to SH-6650, if experienceId === null, it will execute get PublicMediaShare to create the
      // QR code
      const { resp, status, err } = await PublicVisualizationService.getPublicMediaShare(propertyId, shareId);
      payload.share = resp || {};
      payload.status = status;
      payload.err = err;
    } else if (experienceId && userId) {
      const { resp, status, err } = await ShareService.getShare(propertyId, experienceId, shareId);
      payload.share = resp || {};
      payload.status = status;
      payload.err = err;
    } else {
      const { resp, status, err } = await PublicVisualizationService.getPublicShare(propertyId, experienceId, shareId);
      payload.share = resp || {};
      payload.status = status;
      payload.err = err;
    }

    dispatch({
      type: types.GET_CURRENT_SHARE,
      payload,
    });
  };
};

export const resetCurrentShare = () => {
  return (dispatch) => {
    dispatch({
      type: types.RESET_CURRENT_SHARE,
      payload: {},
    });
  };
};
